// extracted by mini-css-extract-plugin
export default {"calendarEventSmall":"SmallCalendarEvent_calendarEventSmall__Mp3kM","iconText":"SmallCalendarEvent_iconText__HoNsN"};